import { request as apiRequest, BaseResponse } from '../api';

/**
 * 服务器时间响应接口
 */
export interface ServerTimeResponse {
  timestamp: number;  // Unix时间戳（秒）
  iso_time: string;   // ISO 8601格式时间字符串
  timezone: string;   // 时区信息
}

/**
 * 获取服务器当前时间
 * 用于客户端时间同步，避免本地时间不准确的问题
 */
export function getServerTime(): Promise<BaseResponse<ServerTimeResponse>> {
  return apiRequest<ServerTimeResponse>('/system/server-time', {
    method: 'GET',
  });
}




